module.exports = __webpack_public_path__ + "img/Online report-rafiki.19a75e6e.svg";